import { Store } from './store'
import {DomainObject} from "../core/_base/crud/models/_domain.model";

export class Location extends DomainObject {
	name: string
	store: Store[]
}
